/**
 * Metafans Tabs & Navigation Effects
 * Handles sliding backgrounds and auto-scrolling for active tabs.
 */

export function initTabs() {
    initSlidingBackground();
    initScrollToActive();
}

// Sliding background for .item-options (Widget Tabs)
function initSlidingBackground() {
    const containers = document.querySelectorAll('.buddypress.widget .item-options');

    containers.forEach(container => {
        const links = container.querySelectorAll('a');

        const updateSlider = (activeLink) => {
            if (!activeLink) return;
            const containerRect = container.getBoundingClientRect();
            const linkRect = activeLink.getBoundingClientRect();

            const offsetLeft = linkRect.left - containerRect.left;
            const width = linkRect.width;

            container.style.setProperty('--slider-x', `${offsetLeft}px`);
            container.style.setProperty('--slider-w', `${width}px`);
        };

        // Initial Position
        const selected = container.querySelector('.selected') || links[0];
        updateSlider(selected);

        // Click Event
        links.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                links.forEach(l => l.classList.remove('selected'));
                link.classList.add('selected');
                updateSlider(link);
            });
        });
    });
}

// Scroll active tab into view on load (for horizontal scrolling navs)
function initScrollToActive() {
    const selectors = ['.bp-navs > ul', '.tophive-forum-tabs > ul'];

    selectors.forEach(selector => {
        const containers = document.querySelectorAll(selector);

        containers.forEach(con => {
            const handleScroll = (tab) => {
                const conRect = con.getBoundingClientRect();
                const tabRect = tab.getBoundingClientRect();
                const offset = tabRect.left - conRect.left;
                // Center the tab
                const scroll = offset - (conRect.width / 2) + (tabRect.width / 2);

                con.scrollBy({ left: scroll, behavior: 'smooth' });
            };

            const tabs = con.querySelectorAll('li');

            // Bind Clicks
            tabs.forEach(tab => {
                tab.addEventListener('click', () => handleScroll(tab));
            });

            // Handle Initial Active State
            const activeTab = con.querySelector('.selected') || con.querySelector('a.active')?.closest('li');
            if (activeTab) {
                // Slight delay to ensure layout is stable
                setTimeout(() => handleScroll(activeTab), 100);
            }
        });
    });
}